import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { MutationBitbucketCloudIntegrationUpdateArgs } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { UPDATE_BITBUCKET_CLOUD_INTEGRATION } from "./gql";

const useUpdateBitbucketCloudIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [bitbucketCloudIntegrationUpdate, { loading }] = useMutation(
    UPDATE_BITBUCKET_CLOUD_INTEGRATION,
    {
      refetchQueries: ["SearchVCSIntegrations"],
    }
  );

  const updateBitbucketCloudIntegration = useCallback(
    (input: MutationBitbucketCloudIntegrationUpdateArgs, successCallback?: () => void) => {
      bitbucketCloudIntegrationUpdate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.bitbucketCloudIntegrationUpdate) {
            reportSuccess({
              message: `Integration ${data.bitbucketCloudIntegrationUpdate.name} was successfully updated`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration Edit - Finish", {
              integration: "Bitbucket Cloud",
            });
          }
        })
        .catch(onError);
    },
    [bitbucketCloudIntegrationUpdate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    updateBitbucketCloudIntegration,
    loading,
  };
};

export default useUpdateBitbucketCloudIntegration;
